import React from 'react'
import { Classes, Dialog } from '@blueprintjs/core'
import { Flex, Icon, Toaster } from '@ui'
import api from '@api'
import { ApolloError } from 'apollo-boost'
import { useFloor } from '@providers/mapProvider'
import css from './unseatAll.module.css'
import { EvoGhostButton, EvoButton } from '@ui/buttons/EvoButton'
import { Button } from '@runeffective/evo-design-system'

export interface UnseatAllPopupDialogProps {
  setunseatAllPopupOpen: (para: boolean) => void
  unseatAllPopupOpen: boolean
  selectedSpaces: string[]
  allEmployeesList: string[]
}

export default function UnseatAllPopup({
  setunseatAllPopupOpen,
  unseatAllPopupOpen,
  selectedSpaces,
  allEmployeesList,
}: UnseatAllPopupDialogProps) {
  const apId = useFloor().apId

  function onClickSubmit() {
    api.space.unAllocate(apId, { assignmentPlanId: apId, spaceIds: selectedSpaces }).then(() => {})
    setunseatAllPopupOpen(false)
    Toaster.success({ message: allEmployeesList.length + ' selected employee was unseated' })
  }

  return (
    <>
      <Dialog
        style={{ paddingBottom: '0px' }}
        isOpen={unseatAllPopupOpen}
        className={css.dialogWidth}
        transitionDuration={200}
        isCloseButtonShown={true}
        canOutsideClickClose={false}
        onClose={() => setunseatAllPopupOpen(false)}
      >
        <div className={css.empList}>
          <Button
            style={{ position: 'absolute', top: '5px', right: '10px' }}
            aria-label="single icon button"
            onClick={() => {
              setunseatAllPopupOpen(false)
            }}
            size="default"
            layout="borderless"
          >
            <Icon name="close" />
          </Button>

          <div>
            <div className={css.dialogHeader}> Occupancy </div>
          </div>
          <div>
            <div className={css.labelText}>Unseat {allEmployeesList.length} employee?</div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Flex style={{ gap: '8px' }} direction="row" justify="space-between">
                <Button
                  layout="borderless"
                  onClick={() => {
                    setunseatAllPopupOpen(false)
                  }}
                  size="default"
                >
                  Cancel
                </Button>
                <Button layout="primary" onClick={() => onClickSubmit()} size="default">
                  Update
                </Button>
              </Flex>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  )
}
